import React from 'react';
import { RegulationDetailModal } from '../../../dashboard/RegulationDetailModal';
import * as dashboardApi from '../../../../api/dashboardApi';
import { Sidebar } from './Sidebar';
import styles from '../../pages/AdminDashboardPage.module.css';
import '../../admin-theme.css';
import type { SectionKey } from './navConfig';

export interface DashboardLayoutProps {
  collapsed: boolean;
  activeSection: SectionKey;
  availableSections?: SectionKey[];
  allowedFeatures?: string[] | null;
  welcomeLabel: string;
  selectedRegulation: dashboardApi.RegulationSummary | null;
  children: React.ReactNode;
  onToggleSidebar: () => void;
  onNavClick: (section: SectionKey) => void;
  onProfileClick: () => void;
  onLogout: () => void;
  onGenerateReport?: () => void;
  onRegulationModalClose: () => void;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  collapsed,
  activeSection,
  availableSections,
  allowedFeatures,
  welcomeLabel,
  selectedRegulation,
  children,
  onToggleSidebar,
  onNavClick,
  onProfileClick,
  onLogout,
  onGenerateReport,
  onRegulationModalClose,
}) => {
  const sidebarWidth = collapsed ? '90px' : '260px';

  return (
    <div
      className={`admin-root ${styles.workspace} ${collapsed ? styles.workspaceCollapsed : ''}`}
      style={{ ['--admin-sidebar-width' as any]: sidebarWidth }}
    >
      <Sidebar
        collapsed={collapsed}
        activeSection={activeSection}
        availableSections={availableSections}
        allowedFeatures={allowedFeatures}
        onToggleCollapse={onToggleSidebar}
        onNavClick={onNavClick}
        onProfileClick={onProfileClick}
        onLogout={onLogout}
      />

      <div className={styles.contentArea}>
        <main className={styles.sectionStage}>{children}</main>
      </div>

      {selectedRegulation && (
        <RegulationDetailModal
          regulation={selectedRegulation}
          onClose={onRegulationModalClose}
        />
      )}
    </div>
  );
};
